import React, { Component, Fragment } from 'react'
import DonutLoader from '../sub-components/DonutLoader';
import logo from '../images/logo.svg';
import loadsStore from '../../stores/loads-store';
import NavHamburger from '../sub-components/NavHamburger/NavContainer';
import Time from '../LoadCallPage/Timer'

import './staffBoard.css'

import {
	Table
} from 'reactstrap';

class StaffBoard extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: true,
            completedLoads: [],
            activeLoads: [],
            loads: [],
            schoolWaitlist:{}
        }
        this.loadEvents = [
            { name: loadsStore.getEventPrefix('getExistingLoads'), func: this.handleExistingLoads },
            { name: loadsStore.getEventPrefix('getWaitlists'), func: this.handleWaitlists },
            { name: loadsStore.getEventPrefix('updateSchoolWaitlist'), func: this.handleUpdateSchoolWaitlist },
            { name: loadsStore.getEventPrefix('createLoad'), func: this.handleNewLoad },
            { name: loadsStore.getEventPrefix('updateAllLoads'), func: this.handleUpdateLoads },
						{ name: loadsStore.getEventPrefix('updateAllLoadsInStaffBoard'), func: this.handleUpdateLoads },
            { name: loadsStore.getEventPrefix('updateLoad2'), func: this.handleUpdateLoad2 },
            { name: loadsStore.getEventPrefix('updateLoadInStaffBoard'), func: this.handleUpdateLoad },
        ]
    }
    componentWillMount = () => {
        this.loadEvents.forEach((evnt) => loadsStore.on(evnt.name, evnt.func))
    }
    componentDidMount() {
        loadsStore.loadAllExistingLoads();
    }
    componentWillUnmount = () => {
        this.loadEvents.forEach((evnt) => loadsStore.removeListener(evnt.name, evnt.func));
    }
    handleNewLoad = (loads) => {
        let activeLoads = this.filterLoads(loads);
        this.setState({ activeLoads })
    }
    handleUpdateLoad2 = (loads) => {
        let activeLoads = this.filterLoads(loads);
        this.setState({ activeLoads })
    }

    handleUpdateLoads = (loads) => {
        let activeLoads = this.filterLoads(loads);
        this.setState({ activeLoads })
    }
    handleUpdateLoad = (load) => {
        let { activeLoads } = this.state;
        let newLoads = [];
        let idx = activeLoads.findIndex(l => l.loadNum === load.loadNum);
        if (idx === -1) {
            newLoads = [...activeLoads, load];
        }
        else {
            newLoads = [...activeLoads];
            newLoads[idx] = load;
        }
        newLoads = this.filterLoads(newLoads)
        this.setState({ activeLoads: newLoads })

    }
    filterLoads = (loads) => {
        return loads
    }
    handleExistingLoads = (loads) => {
        let activeLoads = this.filterLoads(loads.activeLoads);
        this.setState({
            activeLoads,
            isLoading: false,
        });
    }

    handleUpdateSchoolWaitlist = (waitlist) => {

      ////console.log("loadsloadsloadsloadsloads", load)
      //alert('handle update school waitlist');
      console.log(waitlist);
      this.setState({ schoolWaitlist: waitlist });
    }

    handleWaitlists = (waitlists) => {
      console.log('handle waitlists');
      console.log(waitlists);
      // ////console.log("handleExistingLoads",loads)
      var usingWaitlist = false;

      this.setState({ schoolWaitlist: waitlists.schoolWaitlist, jumperWaitlist: waitlists.jumperWaitlist });
    }

    handleUpdateSchoolWaitlist = (waitlist) => {

      ////console.log("loadsloadsloadsloadsloads", load)
      //alert('handle update school waitlist');
      console.log(waitlist);
      this.setState({ schoolWaitlist: waitlist });
    }

    render() {
        let { isLoading } = this.state;

        var staffBoard = [];
        console.log(this.state.activeLoads);
				var ldcolor = 'white';
        this.state.activeLoads.filter(ld => !ld.inAir).forEach((ld,indx) => {
					if(ld.affJumps.length === 0 && ld.tandemJumps.length === 0){

					}
					else{
	          ld.tandemJumps.forEach(jump => {
	            var staffBoardRow =
	            {
									loadNum    :    ld.plane + "-" +ld.planeLoadNum,
									timeRemaining : ld.isPaused?"paused":ld.timeRemaining,
	                type          : jump.displayText.toUpperCase(),
	                instructor    : jump.instructor.nickname + " " + jump.instructor.lastname,
	                student       : jump.student.firstname    + " " + jump.student.lastname,
	                videoPackage  : jump.videoPackageName,
									weight        : jump.studentWeight
	            }
	            if(staffBoardRow.timeRemaining < 3){
	              staffBoardRow.timeRemaining = "NOW"
	            }
	            if(jump.videographer){
	              staffBoardRow.videographer = jump.videographer.nickname + " " + jump.videographer.lastname;
	            }
							staffBoardRow.ldcolor = ldcolor;
	            staffBoard.push(staffBoardRow);
	          })
	          ld.affJumps.forEach(jump => {
	            var staffBoardRow =
	            {
									loadNum    :    ld.plane + "-" +ld.planeLoadNum,
									timeRemaining : ld.isPaused?"paused":ld.timeRemaining,
	                type          : jump.studentPackageName.toUpperCase(),
	                student       : jump.student.firstname    + " " + jump.student.lastname,
	                videoPackage  : jump.videoPackageName,
									weight        : jump.studentWeight
	            }
	            if(staffBoardRow.timeRemaining < 3){
	              staffBoardRow.timeRemaining = "NOW"
	            }
							if(jump.mainInstructor){
								staffBoardRow.instructor = jump.mainInstructor.nickname + " " + jump.mainInstructor.lastname;
							}
	            if(jump.secondaryInstructor){
	              staffBoardRow.instructor = staffBoardRow.instructor + ", " + jump.secondaryInstructor.firstname + " " + jump.secondaryInstructor.lastname;
	            }
	            if(jump.videographer){
	              staffBoardRow.videographer = jump.videographer.firstname + " " + jump.videographer.lastname;
	            }

							staffBoardRow.ldcolor = ldcolor;
	            staffBoard.push(staffBoardRow);
	          })

						if(ldcolor === 'white'){
							ldcolor = '#00FFFF'
						}
						else if (ldcolor === "#00FFFF"){
							ldcolor = 'white';
						}
	          staffBoard.push({})
				}

        })


      if(this.state.schoolWaitlist.tandemJumps){
        this.state.schoolWaitlist.tandemJumps.forEach(jump => {
              var staffBoardRow =
              {
									loadNum       : 'waiting',
									timeRemaining : jump.callRequest,
                  type          : jump.displayText,
                  instructor    : jump.instructor.nickname + " " + jump.instructor.lastname,
                  student       : jump.student.firstname    + " " + jump.student.lastname,
                  videoPackage  : jump.videoPackageName,
									weight        : jump.studentWeight
              }
              if(jump.videographer){
                staffBoardRow.videographer = jump.videographer.firstname + " " + jump.videographer.lastname;
              }
							staffBoardRow.ldcolor = ldcolor;

              staffBoard.push(staffBoardRow);
            })
      }

      if(this.state.schoolWaitlist.affJumps){
        this.state.schoolWaitlist.affJumps.forEach(jump => {

              var staffBoardRow =
              {
									loadNum    :    'waiting',
									timeRemaining : jump.callRequest,
                  type          : jump.studentPackageName.toUpperCase(),
                  student       : jump.student.firstname    + " " + jump.student.lastname,
                  videoPackage  : jump.videoPackageName,
									weight        : jump.studentWeight
              }
							if(jump.mainInstructor){
								staffBoardRow.instructor = jump.mainInstructor.nickname + " " + jump.mainInstructor.lastname;
							}
              if(jump.secondaryInstructor){
                staffBoardRow.instructor = staffBoardRow.instructor + ", " + jump.secondaryInstructor.firstname + " " + jump.secondaryInstructor.lastname;
              }
              if(jump.videographer){
                staffBoardRow.videographer = jump.videographer.nickname + " " + jump.videographer.lastname;
              }
							staffBoardRow.ldcolor = ldcolor;

              staffBoard.push(staffBoardRow);
            })
      }

        var staffRender = staffBoard.map(row => {
					var color = 'yellow';
					if(row.type && row.type.toLowerCase().includes('tandem')){
						color = '#F8836A'
					}
          return(

            <tr style={{ margin :0, padding:0}}>

              <td style={{color: row.ldcolor}}> <strong>{row.loadNum}</strong></td>
							<td style={{color: row.ldcolor}}><strong>
								{!isNaN(Number(row.timeRemaining))?
									<Time command={"start"} startTime={row.timeRemaining} />:row.timeRemaining}</strong></td>
							<td style={{color: color}} > <strong>{row.type}</strong></td>
							<td style={{color: row.ldcolor}}><strong>{row.instructor}</strong></td>
							<td style={{color: row.ldcolor}}><strong>{row.student}</strong></td>
							<td style={{color: row.ldcolor}}><strong>{row.videoPackage}</strong></td>
              <td style={{color: row.ldcolor}}><strong>{row.weight?row.weight:""}</strong></td>
							<td style={{color: row.ldcolor}}><strong>{row.videographer}</strong></td>
            </tr>

          )
        })

        return (
          <React.Fragment >
              <NavHamburger />

                <Table dark className="staff-table">
                  <thead>
                    <tr>
											<th>Load</th>
											<th>Call Time</th>
                      <th>Type</th>
                      <th>Instructor</th>
                      <th>Student</th>
                      <th>Video Type</th>
											<th>Weight</th>
                      <th>Videographer</th>
                    </tr>
                  </thead>
                  <tbody>
                    {staffRender}
                  </tbody>

                </Table>

            <span className="staff-table-footer"><img src={logo} alt="logo" className={`dizio-logo`} /></span>
          </React.Fragment>
        )
    }
}
export default StaffBoard
